module.exports = __webpack_public_path__ + "img/w4_banner.ed947d80.jpg";